"use client";
import { r as e, t } from "./registration-BkPgmtZ2.js";
import { t as n } from "./tokens-DBlg30G8.js";
//#region src/openers/neonSlam/tokens.ts
var r = n, i = t(() => import("./NeonSlamOpener-gAo1tOt8.js"), r);
function a() {
	e("neon_slam", i);
}
//#endregion
export { a as n, r, i as t };

//# sourceMappingURL=neonSlam-Dq4On35E.js.map